export const generateRoomShareLink = (roomId: string): string => {
  const baseUrl = window.location.origin;
  return `${baseUrl}/room/${roomId}`;
};

export const getRoomIdFromUrl = (): string | null => {
  // Check if we're on a room page
  const path = window.location.pathname;
  const match = path.match(/\/room\/(.+)/);
  return match ? match[1] : null;
};

export const generateRoomCode = (): string => {
  return Math.random().toString(36).substring(2, 8).toUpperCase();
};
